module.exports = __webpack_public_path__ + "img/nightstalker.923afdfa.webp";